import { VersionFirebase } from './version-firebase';

// TODO: adicionar tudo que é utilizado localStorage
export class LocalConfig {
  remoteVersion: VersionFirebase;
  lastLocalVersion: string;
  alreadyRunTourApp: boolean;
  lastEstablishmentId: number;
  lastPlaceId: number;

  alreadySeePrintHint: boolean;
  hideTipsHome: boolean;

  showSmsWalletNews: boolean;
  hideHomeNewsVersion: boolean;

  /**
   * Objeto que grava todos as lojas { [storeId] : trialRemainingDays }
   * Ex: { 2: objeto, 10: objeto }
   */
  //remainingDaysByStore: any;
  alreadySeeLegacyAccountAlert: boolean;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/local-config.model.ts